module.exports = __webpack_public_path__ + "img/quxiao4_pc.a0a8790.jpg";